import { render, staticRenderFns } from "./AuthLayout.vue?vue&type=template&id=5ea58fbc"
import script from "./AuthLayout.vue?vue&type=script&lang=js"
export * from "./AuthLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tomi/Projects/ingeniAR/rrhh/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ea58fbc')) {
      api.createRecord('5ea58fbc', component.options)
    } else {
      api.reload('5ea58fbc', component.options)
    }
    module.hot.accept("./AuthLayout.vue?vue&type=template&id=5ea58fbc", function () {
      api.rerender('5ea58fbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AuthLayout.vue"
export default component.exports